import { render, staticRenderFns } from "./ConversionRatesChart.vue?vue&type=template&id=1f5ec0bc&scoped=true"
import script from "./ConversionRatesChart.vue?vue&type=script&lang=js"
export * from "./ConversionRatesChart.vue?vue&type=script&lang=js"
import style0 from "./ConversionRatesChart.vue?vue&type=style&index=0&id=1f5ec0bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5ec0bc",
  null
  
)

export default component.exports